import { render, staticRenderFns } from "./TmPopup.vue?vue&type=template&id=f928b766&"
import script from "./TmPopup.vue?vue&type=script&lang=js&"
export * from "./TmPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports